import { SidebarGroup, SidebarMenu } from 'designSystem/components/Sidebar'
import type { NavItemConfig } from 'features/navbar/navConfig'
import { SelectedTab } from 'features/navbar/types'
import type { MouseEvent } from 'react'

import { capSidebarNavItems } from './capSidebarNavItems'
import { EmbeddedSidebarHomeNavItem } from './EmbeddedSidebarHomeNavItem'
import { EmbeddedSidebarMoreFeaturesMenu } from './EmbeddedSidebarMoreFeaturesMenu'

interface EmbeddedSidebarHomeNavProps {
  chatLayout: boolean
  maxRows: number | undefined
  navItems: Array<[SelectedTab, NavItemConfig]>
  onNavigateDestination: (
    destinationKey: string,
    label: string,
    href: string
  ) => void
  onNavigateItemSelected: (
    event: MouseEvent<HTMLAnchorElement>,
    destinationKey: string,
    label: string
  ) => void
  orgID: string | undefined
  selectedTab: SelectedTab | undefined
  siteID: string | undefined
}

export function EmbeddedSidebarHomeNav({
  chatLayout,
  maxRows,
  navItems,
  onNavigateDestination,
  onNavigateItemSelected,
  orgID,
  selectedTab,
  siteID,
}: EmbeddedSidebarHomeNavProps) {
  const { hiddenItems, visibleItems } = capSidebarNavItems({
    isActive: ([tabKey]) => tabKey === selectedTab,
    items: navItems,
    maxRows,
  })

  return (
    <SidebarGroup>
      <SidebarMenu>
        {visibleItems.map(([tabKey, config]) => (
          <EmbeddedSidebarHomeNavItem
            chatLayout={chatLayout}
            key={tabKey}
            config={config}
            isActive={selectedTab === tabKey}
            onNavigate={onNavigateItemSelected}
            orgID={orgID}
            siteID={siteID}
            tabKey={tabKey}
          />
        ))}
        {hiddenItems.length > 0 ? (
          <EmbeddedSidebarMoreFeaturesMenu
            items={hiddenItems}
            onNavigate={onNavigateDestination}
            orgID={orgID}
            siteID={siteID}
          />
        ) : null}
      </SidebarMenu>
    </SidebarGroup>
  )
}
